export const docLinkPreviewInfoValidPeriod = 30 * 60 * 1000; // 30 minutes
export const maxActiveGetWacInfoOperation = 2;
export const SP_LINK_CLICK_EVENT_LISTENER = 'SP_LINK_CLICK_EVENT_LISTENER';
export const SP_LINK_MOUSEUP_EVENT_LISTENER = 'SP_LINK_MOUSEUP_EVENT_LISTENER';
